import { jsx as _jsx } from "react/jsx-runtime";
import { TableBody, TableCell, TableRow, Typography } from '@mui/material';
var BaseTableNoData = function (_a) {
    var numberColumns = _a.numberColumns;
    return (_jsx(TableBody, { children: _jsx(TableRow, { children: _jsx(TableCell, { colSpan: numberColumns, className: 'h-[340px]', children: _jsx("div", { className: 'absolute top-[calc(50%+25px)] left-1/2 -translate-x-1/2 -translate-y-1/2 w-fit', children: _jsx(Typography, { variant: 'h3', children: "Nodata" }) }) }) }) }));
};
export default BaseTableNoData;
